<template>
	<div class="connect_bg">
		<div class="connect_wrap">
			<div class="close-btn" @click="close"></div>
			<div class="tips-item-title">
				<span class="icon"></span><span>如何修改缓存路径?</span>
			</div>

			<div class="tips-item-desc">
				<span class="icon"></span
				><span
					>控制面板→共享文件夹→选中“OWSpeedup”→点击编辑→常规→所在位置→选择用于缓存的磁盘。</span
				>
			</div>
			<div class="tips-sure-btn" @click="close">确 定</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},
	props: ["isFailed", "name"],
	methods: {
		close: function () {
			let _that = this;
			_that.$emit("close");
		},
	},
	mounted() {
		let _that = this;
	},
};
</script>

<style lang="less" scoped>
.connect_bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9;
	.connect_wrap {
		width: 460px;
		height: 220px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -110px;
		margin-left: -230px;
		background-color: #f5f5f5;
		border-radius: 5px;
		text-align: center;

		.close-btn {
			width: 20px;
			height: 20px;
			background-image: url(../assets/home/node/close.png);
			background-size: 100% 100%;
			position: absolute;
			right: 10px;
			top: 10px;
		}

		.close-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}

		.tips-item-title {
			text-align: left;
			color: #666666;
			font-size: 18px;
			font-weight: bolder;
			margin-top: 35px;
			text-align: center;
			span {
				display: inline-block;
				vertical-align: middle;
			}
		}
		.tips-item-desc {
			text-align: left;
			color: #666666;
			font-size: 14px;
			width: 360px;
			margin: 0 auto;
			margin-top: 15px;
			line-height: 24px;
			span {
				vertical-align: top;
				display: inline-block;
			}
		}

		.tips-sure-btn {
			margin: 25px auto 20px auto;
			background-color: #215fe4;
			border-radius: 18px;
			width: 140px;
			height: 36px;
			line-height: 36px;
			color: #ffffff;
			font-size: 15px;
		}
		.tips-sure-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}
}
</style>